<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import { helpers } from "../../../helpers/helpers-validate";
import MaskedInput from "vue-text-mask";
Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
let nit = (value) => helpers.nitIsValid(value);
let correo = (value) => helpers.correo(value);
/**
 * new orden component
 */
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    Vuetable,
    VuetablePagination,
    Loader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      // variables para detalle
      ubicacionModel: 0,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      arrayEstante: [],
      estanteModel: 0,
      formget: {
        descripcion: "",
        pasillo: "",
        seccion: "",
        estante: "",
        departamentoId: "",
        id: 0,
      },
      activa_proveedor: false,
      cabezera: [
        { key: "Opciones", label: "Opciones", thClass: "cell1" },
        { key: "codigo", label: "Codigo", thClass: "cell1" },
        { key: "producto", label: "Producto", thClass: "cell1" },
        { key: "existencia", label: "Existencia", thClass: "cell1" },
        { key: "cantidad", label: "Cantidad", thClass: "cell1" },
        { key: "precio_compra", label: "Precio Compra", thClass: "cell1" },
        { key: "porcentaje_venta", label: "Porcentaje", thClass: "cell1" },
        { key: "precio_venta", label: "Precio Venta", thClass: "cell1" },
        // { key: "ubicaciones", label: "Departamentos", thClass: "cell1" },
        // { key: "unidad", label: "Presentacion", thClass: "cell1" },
        { key: "subtotal", label: "Subtotal", thClass: "cell1" },
      ],
      arrayProveedor: [],
      arrayDepa: [],
      arrayProveedores: [],
      apiUrl: process.env.VUE_APP_URL,
      apiBase:
        process.env.VUE_APP_URL +
        "productos/stock/busqueda?departamento=" +
        0 +
        "&estante=" +
        0,
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },

      fields: [
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
          dataClass: "list-item-heading",
        },
        {
          name: "codigo",
          title: "Código",
          sortField: "codigo_stock",
          width: "20%",
          dataClass: "list-item-heading",
        },
        {
          name: "producto",
          title: "Producto",
          // sortField: 'producto.nombre_producto',
          width: "20%",
          dataClass: "list-item-heading",
        },
        // {
        //   name: 'unidad',
        //   title: 'Unidad medida',
        //   // sortField: 'descripcion_departamento',
        //   width: "20%",
        // },     
        {
          name: "proveedor",
          title: "Proveedor",
          //sortField: "proveedore.company_proveedor",
          width: "10%",
          dataClass: "list-item-heading",
        },
        {
          sortField: "Stock.existencia_stock",
          name: "existencia",
          title: "Existencia",
          width: "10%",
          dataClass: "list-item-heading",
        },
        {
          name: "departamento.nombre_departamento",
          title: "Ubicación",
          width: "20%",
          dataClass: "list-item-heading",
        },
        {
          name: "estante.nombre_pasillo",
          title: "Pasillo",
          width: "20%",
          dataClass: "list-item-heading",
        },
      ],
      formPro: {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        proveedor: "",
        total: "",
        state: true,
        id: 0,
      },
      formProveedor: {
        nombre: "",
        apellido: "",
        nit: "C/F",
        opciones: ["MASCULINO", "FEMENINO"],
        direccion: "",
        telefono: "",
        correo: "",
        cui: "",
        sexo: "",
        compania: "",
        direc: "",
        state: true,
        id: 0,
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          porcentaje_venta: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "Orden de Compra",
      items: [
        {
          text: "Compras",
          href: "/",
        },
        {
          text: "Orden de Compra",
          active: true,
        },
      ],
      searchType: [
        { nombre: "Nombre producto", value: "producto" },
        { nombre: "Código producto", value: "codigo" },
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_producto",
      searchLabel: { nombre: "Nombre producto", value: "producto" },
      filterLabel: { nombre: "Nombre producto ", value: "producto" },
      showModalL: false, //Loading
      showModalNP: false, //Nuevo Proveedor
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      arrayDetalle: [],
      idDepartamento: 0,
      traslado_masivo: false,
      arrayDet: [],
    };
  },
  validations: {
    formProveedor: {
      nombre: { required },
      apellido: { required },
      nit: { nit, required },
      direccion: { required },
      telefono: { required },
      correo: { correo, required },
      cui: { required },
      sexo: { required },
      compania: { required },
      direc: { required },
    },
    formPro: {
      fecha_compra: { required },
      tienda: { required },
      proveedor: { required },
      total: { required },
    },
    arrayDetalle: {
      required,
      $each: {
        cantidad: {
          required,
        },
        ubicacion: {
          required,
        },
      },
    },
    data: { required },
  },
  mounted() {
    console.log("tryoe value", typeof this.ubicacionModel);
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.getproveedor();
    this.gettienda();
    console.log(this.userT);
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      let resultado = 0.0;
      if (this.arrayDetalle.length) {
        for (let i = 0; i < this.arrayDetalle.length; i++) {
          if (
            this.arrayDetalle[i].subtotal == "" ||
            this.arrayDetalle[i].subtotal == null
          ) {
            resultado = resultado + 0;
          } else {
            resultado =
              parseFloat(resultado) + parseFloat(this.arrayDetalle[i].subtotal);
          }
        }
      }

      return resultado.toFixed(2);
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // NUEVAS MODIFICACIONES
    async selectOpc() {
      let me = this;
      // console.log(me.ubicacionModel);

      this.arrayEstante = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL +
            "departamentos/estante/busqueda?departamento=" +
            me.ubicacionModel.id,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        me.arrayEstante = response.data.data;
      } catch (error) {
        console.log(error);
      }
      this.cambioApiBase()
    },
    cambioApiBase(val) {
      let ubicaciondep=this.ubicacionModel!=0?this.ubicacionModel.id:0;
      let ubicacionest=this.estanteModel !=0?this.estanteModel.id:0;
      console.log(ubicaciondep,ubicacionest)
      if(val==true){
      this.apiBase =
        process.env.VUE_APP_URL +
        "productos/stock/busqueda_compras?departamento=" +
        ubicaciondep +
        "&estante=" +
        ubicacionest +
        "&activador=" +
        !this.activa_proveedor +
        "&proveedor=" +
        this.formPro.proveedor.id;}
        else{
          this.apiBase =
        process.env.VUE_APP_URL +
        "productos/stock/busqueda_compras?departamento=" +
        ubicaciondep +
        "&estante=" +
        ubicacionest;
        }
      // this.onChangePage(1);
    },
    // fin nuevas modificaciones
    async getDepartamento() {
      const response = await axios.get(
        process.env.VUE_APP_URL +
          "departamentos/busqueda1?id=" +
          this.formPro.tiendaid,
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.arrayDepa = response.data.ubicacion;
    },

    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();

          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formProveedor.nombre = "";
      this.formProveedor.apellido = "";
      this.formPro.nit = "C/F";
      this.formProveedor.direccion = "";
      this.formProveedor.telefono = "";
      this.formProveedor.correo = "";
      this.formProveedor.cui = "";
      this.formProveedor.sexo = "";
      this.formProveedor.compania = "";
      this.formProveedor.direc = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalNP = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action) {
      if (action == "new-item") {
        this.limpiarVariables();
      }
    },
    getDatosProveedor() {
      this.cambioApiBase();
    },
    async selectProveedor(valor) {
      this.arrayProveedor = [];
      for (var i = 0; i < this.arrayProveedores.length; i++) {
        const estado = this.arrayProveedores[i].nombre
          .toLowerCase()
          .includes(valor.toLowerCase());
        if (estado === true) {
          this.arrayProveedor.push(this.arrayProveedores[i]);
          // console.log(this.arrayProveedor)
        } else {
          // console.log("nada")
        }
      }
    },
    async gettienda() {
      let me = this;
      me.formPro.tiendaid = "";
      me.formPro.tienda = "";
      axios
        .get(process.env.VUE_APP_URL + "tiendas/select", {
          headers: { "x-token": this.userT.token },
        })
        .then(
          function (response) {
            me.formPro.tienda = response.data[0].nombre_tienda;
            me.formPro.tiendaid = response.data[0].id;
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.getDepartamento();
        });
    },
    tomandototal() {
      let temp = 0;
      temp = parseFloat(this.calcularTotal);
      this.formPro.total = temp;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();

      if (
        this.formPro.proveedor == "" ||
        this.formPro.tienda == "" ||
        this.formPro.proveedor == null ||
        this.formPro.factura == "" ||
        this.$v.arrayDetalle.$error
      ) {
        // console.log("retroll")
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
      }
    },
    //Guardar registro
    save() {
      const { tiendaid, fecha_compra, observaciones, proveedor, total } =
        this.formPro;
      const datos = this.arrayDetalle.map(function (item) {
        return {
          cantidad: item.cantidad,
          precio_compra: item.precio_compra,
          precio_venta: item.precio_venta,
          subtotal: item.subtotal,
          presentacionId: item.presentacionId,
          id: item.id,
          ubicacion: item.ubicacion,
          // observaciones : observaciones
          // sub_presentacion:item.sub_presentacion
        };
      });
      // console.log(proveedor)
      axios
        .post(
          process.env.VUE_APP_URL + "ordenes/store",
          {
            fecha_compra: this.customFormatter(fecha_compra),
            usuario: this.userT.id,
            tienda: tiendaid,
            proveedor: proveedor.id,
            total,
            observaciones,
            data: datos,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Registro Guardado", this.options);
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
          this.$router.push({
            name: "ordendecompra",
            shallow: true,
          });
        });
    },
    // Funciones para trabajar con detalles
    eliminarDetalle({ index }) {
      let me = this;
      me.arrayDetalle.splice(index, 1);
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // Funciones para formatos
    updateporcentaje({ item, index }) {
      const me = this;
      console.log(item);
      if (me.arrayDetalle[index].porcentaje_venta != "") {
        me.arrayDetalle[index].precio_venta =
          (parseFloat(me.arrayDetalle[index].porcentaje_venta) / 100) *
            parseFloat(
              me.converMaskToNumberxd(me.arrayDetalle[index].precio_compra)
            ) +
          parseFloat(
            me.converMaskToNumberxd(me.arrayDetalle[index].precio_compra)
          );
      }
      this.$refs.table.refresh();
    },
    updateDisableDates({ item, index }) {
      const me = this;
      console.log(item);
      if (me.arrayDetalle[index].cantidad != "") {
        me.arrayDetalle[index].subtotal =
          parseFloat(me.arrayDetalle[index].cantidad) *
          parseFloat(
            me.converMaskToNumberxd(me.arrayDetalle[index].precio_compra)
          );
      }
      this.$refs.table.refresh();

      // item.no_extras = 0;
    },
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
    getLabel: function (val) {
      return val.nombre_departamento;
    },
    getLabel1: function (val) {
      return this.ubicacionModel.estado_tipo == true
        ? val.nombre_estante
        : val.nombre_pasillo;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    trasladoDetalle() {
      const me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/stock/busqueda_compras?departamento=" +
            this.ubicacionModel.id +
            "&estante=" +
            this.estanteModel.id +
            "&activador=" +
            this.activa_proveedor +
            "&proveedor=" +
            this.formPro.proveedor.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.arrayDet = response.data.data;
        })
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          for (let i = 0; i < this.arrayDet.length; i++) {
            if (this.traslado_masivo == true) {
              if (this.encuentra(this.arrayDet[i].Stock.id)) continue;
              me.arrayDetalle.push({
                precio_compra: this.arrayDet[i].Stock.precio_compra_stock,
                precio_venta: this.arrayDet[i].Stock.precio_venta_stock,
                presentacionId: this.arrayDet[i].Stock.presentacioneId,
                presentacion:
                  this.arrayDet[i].Stock.presentacione.nombre_presentacion,
                id: this.arrayDet[i].Stock.id,
                ubicacion: this.arrayDet[i].departamentoId,
                producto: this.arrayDet[i].Stock.producto.nombre_producto,
                codigo: this.arrayDet[i].Stock.codigo_stock,
                existencia: this.arrayDet[i].Stock.existencia_stock,
                cantidad: "",
                subtotal: 0,
              });
            } else {
              me.arrayDetalle.splice(me.arrayDetalle.length - 1);
            }
          }
        });
    },
    agregarDetalle(data) {
      const me = this;
      // console.log(data);
      me.arrayDetalle.push({
        precio_compra: data.Stock.precio_compra_stock,
        precio_venta: data.Stock.precio_venta_stock,
        presentacionId: data.Stock.presentacioneId,
        presentacion: data.Stock.presentacione.nombre_presentacion,
        id: data.Stock.id,
        ubicacion: data.departamentoId,
        producto: data.Stock.producto.nombre_producto,
        codigo: data.Stock.codigo_stock,
        existencia: data.Stock.existencia_stock,
        cantidad: "",
        porcentaje_venta: 0,
        subtotal: 0,
      });
      // console.log(me.arrayDetalle);
    },
    verificarstock(stock) {
      const me = this;
      // console.log(stock)
      if (me.encuentra(stock["stockId"].toString())) {
        return true;
      }
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].id.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },
    async getproveedor() {
      this.arrayProveedores = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL + "proveedores/busqueda",
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayProveedores = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
  },
};
</script>

<template>
  <Layout>
    <!-- Modal de Nuevo Registro-->
    <b-modal
      centered
      @show="openModal('save')"
      @hidden="openModal('save')"
      v-model="showModalNP"
      id="modalSaveP"
      ref="modalSaveP"
      title="Nuevo Proveedor"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form>
        <b-tabs
          justified
          nav-class="nav-tabs-custom"
          content-class="p-3 text-muted"
        >
          <b-tab active>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Datos Generales</span>
            </template>

            <div class="col-12">
              <!-- Nombre -->
              <div class="mb-3">
                <label for="name">Nombre</label>
                <input
                  id="name"
                  v-model="$v.formProveedor.nombre.$model"
                  type="text"
                  class="form-control"
                  placeholder="Ingrese un nombre"
                  :class="{
                    'is-invalid': $v.formProveedor.nombre.$error,
                  }"
                  @input="$v.formProveedor.nombre.$touch()"
                />
                <div
                  v-if="
                    $v.formProveedor.nombre.$error &&
                    !$v.formProveedor.nombre.required
                  "
                  class="invalid-feedback"
                >
                  El nombre es obligatorio.
                </div>
              </div>
            </div>
            <!-- Apéllido -->
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Apellido</label>
                <input
                  id="phone"
                  v-model.trim="$v.formProveedor.apellido.$model"
                  :state="!$v.formProveedor.apellido.$error"
                  type="text"
                  class="form-control"
                  placeholder="Ingrese un Apellido"
                />
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formProveedor.apellido.$error &&
                      !$v.formProveedor.apellido.required,
                  }"
                >
                  Apellido es requerido.
                </div>
              </div>
            </div>
            <!-- Nit -->
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Nit</label>
                <input
                  id="phone"
                  v-model.trim="$v.formProveedor.nit.$model"
                  :class="{ 'is-invalid': $v.formProveedor.nit.$error }"
                  :state="!$v.formProveedor.nit.$error"
                  type="text"
                  class="form-control"
                  placeholder="C/F"
                  @input="$v.formProveedor.nit.$touch()"
                />
                <div v-if="$v.formProveedor.nit.$error">
                  <div
                    class="alert alert-danger"
                    v-if="!$v.formProveedor.nit.nit"
                  >
                    El número de NIT no es valido.
                  </div>
                </div>
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formProveedor.nit.$error &&
                      !$v.formProveedor.nit.required,
                  }"
                >
                  Nit es requerido.
                </div>
              </div>
            </div>
            <!-- Identificacion -->
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Identificación</label>
                <masked-input
                  v-model.trim="formProveedor.cui"
                  :class="{
                    'is-invalid': $v.formProveedor.cui.$error,
                  }"
                  :mask="[
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                  ]"
                  class="form-control"
                  placeholder="Ingrese Cui"
                />
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formProveedor.cui.$error &&
                      !$v.formProveedor.cui.required,
                  }"
                >
                  Identificacion Requerida.
                </div>
              </div>
            </div>
            <!-- Sexo -->
            <div class="col-12">
              <div class="mb-3">
                <label>Sexo</label>
                <v-select
                  v-model.trim="$v.formProveedor.sexo.$model"
                  :state="!$v.formProveedor.sexo.$error"
                  :options="formProveedor.opciones"
                />
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formProveedor.sexo.$error &&
                      !$v.formProveedor.sexo.required,
                  }"
                >
                  Debe seleccionar el sexo
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">Información</span>
            </template>

            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Dirección</label>
                <input
                  id="phone"
                  v-model.trim="$v.formProveedor.direccion.$model"
                  :state="!$v.formProveedor.direccion.$error"
                  type="text"
                  class="form-control"
                  placeholder="Ingrese Dirección"
                />
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formProveedor.direccion.$error &&
                      !$v.formProveedor.direccion.required,
                  }"
                >
                  Dirección Requerida.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Teléfono</label>
                <masked-input
                  v-model.trim="formProveedor.telefono"
                  :class="{
                    'is-invalid': $v.formProveedor.cui.$error,
                  }"
                  :state="!$v.formProveedor.telefono.$error"
                  :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                  class="form-control"
                  placeholder="Ingrese el número de teléfono"
                />
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formProveedor.telefono.$error &&
                      !$v.formProveedor.telefono.required,
                  }"
                >
                  Telefono Requerido
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="correo">Correo</label>
                <input
                  id="correo"
                  v-model.trim="formProveedor.correo"
                  :state="!$v.formProveedor.correo.$error"
                  type="email"
                  class="form-control"
                  placeholder="Ingrese Correo"
                  @input="$v.formProveedor.correo.$touch()"
                />
                <div v-if="$v.formProveedor.correo.$error">
                  <div
                    class="alert alert-danger"
                    v-if="!$v.formProveedor.correo.correo"
                  >
                    Correo invalido.
                  </div>
                </div>
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formProveedor.correo.$error &&
                      !$v.formProveedor.correo.required,
                  }"
                >
                  Correo Requerido.
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Nombre de la empresa</label>
                <input
                  id="phone"
                  v-model.trim="$v.formProveedor.compania.$model"
                  :state="!$v.formProveedor.compania.$error"
                  type="text"
                  class="form-control"
                  placeholder="Ingrese Nombre"
                />
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formProveedor.compania.$error &&
                      !$v.formProveedor.compania.required,
                  }"
                >
                  Nombre Requerido.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Dirección de la empresa</label>
                <input
                  id="phone"
                  v-model.trim="$v.formProveedor.direc.$model"
                  :state="!$v.formProveedor.direc.$error"
                  type="text"
                  class="form-control"
                  placeholder="Ingrese Dirección"
                />
                <div
                  :class="{
                    'invalid-feedback': true,
                    'd-block':
                      $v.formProveedor.direc.$error &&
                      !$v.formProveedor.direc.required,
                  }"
                >
                  Dirección Requerido.
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>

        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="showModalN = false"
            >Cerrar</b-button
          >
          <b-button @click="validaciones('save')" variant="success" class="ms-1"
            >Guardar</b-button
          >
        </div>
      </form>
    </b-modal>

    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <PageHeader :title="title" :items="items" />
    <!-- ESTA PARTE ES PARA LA CABECERA -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row">
                <div class="col-">
                  <div class="row">
                    <div class="col">
                      <h4>Datos Generales</h4>
                    </div>
                    <div class="col" align="center">
                      <div class="mt-4 mt-sm-0">
                        <p class="text-muted mb-2">Total</p>
                        <h3>
                          {{
                            formatQuetzales(
                              formPro.total > 0 ? formPro.total : 0.0
                            )
                          }}
                        </h3>
                      </div>
                    </div>
                    <div class="col" align="right">
                      <div>
                        <router-link
                          :to="{
                            name: 'ordendecompra',
                          }"
                        >
                          <b-button
                            variant="outline-primary"
                            type="button"
                            class="btn btn-rounded mb-2 me-2"
                          >
                            <i class="mdi mdi-arrow-collapse-left"></i> Regresar
                          </b-button>
                        </router-link>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-2">
                      <div>
                        <p class="text-muted mb-2">Proveedor</p>
                        <v-select
                          v-model.trim="$v.formPro.proveedor.$model"
                          :state="!$v.formPro.proveedor.$error"
                          :options="arrayProveedor"
                          @search="selectProveedor"
                          @input="getDatosProveedor"
                          placeholder="Buscar Proveedor..."
                          label="nombre"
                        >
                          <!--  <template slot="no-options">
                                    <div class="d-grid gap-4">
                                    <b-button
                                      class="mb-0"
                                      block variant="primary" size="sm"
                                      @click="onActionClicked('new-item')"
                                      v-b-modal.modalSaveP
                                      >Nuevo Proveedor</b-button
                                    >
                                    </div>
                                  </template> -->
                        </v-select>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formPro.proveedor.$error &&
                              !$v.formPro.proveedor.required,
                          }"
                        >
                          Debe seleccionar un Proveedor
                        </div>
                        <div class="form-check form-switch">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="is-loader1"
                            v-model="activa_proveedor"
                            @input="cambioApiBase(true)"
                          />
                          <label class="form-check-label" for="is-loader"
                            >Proveedor</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-1">
                      <div class="mt-4 mt-sm-0">
                        <p class="text-muted mb-2">Sucursal</p>
                        <input
                          disabled
                          id="name"
                          v-model="$v.formPro.tienda.$model"
                          type="text"
                          class="form-control"
                          placeholder="Registre una Tienda"
                          :class="{
                            'is-invalid': $v.formPro.tienda.$error,
                          }"
                        />
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formPro.tienda.$error &&
                              !$v.formPro.tienda.required,
                          }"
                        >
                          Debe Registrar una tienda
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div>
                        <p class="text-muted mb-2">Fecha de Compra</p>
                        <date-picker
                          v-model.trim="$v.formPro.fecha_compra.$model"
                          :state="!$v.formPro.fecha_compra.$error"
                          :first-day-of-week="1"
                          lang="en"
                        ></date-picker>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formPro.fecha_compra.$error &&
                              !$v.formPro.fecha_compra.required,
                          }"
                        >
                          Debe ingresar una fecha
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <p class="text-muted">Ubicación</p>
                      <v-select
                        @input="selectOpc()"
                        v-model="ubicacionModel"
                        :options="arrayDepa"
                        :get-option-label="getLabel"
                      >
                      </v-select>
                    </div>
                    <div class="col-md-2">
                      <p class="text-muted">
                        {{
                          ubicacionModel.estado_tipo == 1
                            ? "Departamentos"
                            : "Pasillos"
                        }}
                      </p>
                      <v-select
                        @input="cambioApiBase()"
                        v-model="estanteModel"
                        :options="arrayEstante"
                        :get-option-label="getLabel1"
                      >
                      </v-select>
                    </div>
                    <div class="col-md-2">
                      <p class="text-muted">observaciones</p>
                      <textarea
                        name="textarea"
                        v-model="formPro.observaciones"
                        rows="2"
                        cols="40"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- ESTOS TABS SON PARA EL DETALLE -->
    <b-tabs
      justified
      nav-class="nav-tabs-custom"
      content-class="p-3 text-muted"
    >
      <b-tab active>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <h5><i class="bx bxs-folder-plus"></i></h5>
          </span>
          <h5>
            <span class="d-none d-sm-inline-block">
              <i class="bx bxs-folder-plus"></i>Seleccionar Producto</span
            >
          </h5>
        </template>
        <div class="row">
          <div class="col-12">
            <Loader :loading="loadingtable">
              <div class="row mt-4">
                <div class="col-sm-12 col-md-2">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Mostrar&nbsp;
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        @input="changePageSize()"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-2">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="is-loader23"
                      v-model="traslado_masivo"
                      @input="trasladoDetalle"
                    />
                    <label class="form-check-label" for="is-loader1"
                      >Agregar Todo</label
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-2">
                  <div
                    id="tickets-table_length"
                    class="dataTables_length text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      <b-dropdown v-if="searchType" id="ddown1" size="sm">
                        <template v-slot:button-content>
                          {{ "Buscar por: " + searchLabel.nombre }}
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <b-dropdown-item
                          v-for="(search, index) in searchType"
                          :key="index"
                          @click="changeTypeSearch(search)"
                          >{{ search.nombre }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 text-md-start">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="search"
                        type="search"
                        @input="onFiltered()"
                        placeholder="Buscar..."
                        class="form-control form-control-sm"
                      ></b-form-input>
                    </label>
                  </div>
                </div>

                <div class="col-sm-12 col-md-5">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  ></div>
                </div>

                <!-- End search -->
              </div>
              <vuetable
                small
                striped
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :http-options="httpOptions"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fields"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div
                  slot="actions"
                  slot-scope="props"
                  v-if="verificarstock(props.rowData) != true"
                >
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Agregar"
                      variant="outline-primary"
                      @click="agregarDetalle(props.rowData)"
                      ><i class="bx bx-check"></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="producto" slot-scope="props">
                  <h6>{{ props.rowData.Stock.producto.nombre_producto }}</h6>
                </div>
                <!-- <div slot="unidad" slot-scope="props">
                              <h6>{{props.rowData.Stock.presentacione.nombre_presentacion}}</h6>
                            </div> -->
                <div slot="codigo" slot-scope="props">
                  <h6>{{ props.rowData.Stock.codigo_stock }}</h6>
                </div>
                <div
                  slot="proveedor"
                  slot-scope="props"
                  v-if="props.rowData.Stock.proveedore"
                >
                  <h6>{{ props.rowData.Stock.proveedore.company_proveedor }}</h6>
                </div>
                <div slot="existencia" slot-scope="props">
                  <h6>{{ props.rowData.Stock.existencia_stock }}</h6>
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </b-tab>

      <!-- TAB DE DETALLES -->
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <h5><i class="bx bxs-food-menu"></i></h5>
          </span>
          <h5>
            <span class="d-none d-sm-inline-block">
              <i class="bx bxs-food-menu"></i>Asignar detalles</span
            >
          </h5>
        </template>

        <b-table
          small
          striped
          v-if="arrayDetalle.length > 0"
          ref="table"
          :items="arrayDetalle"
          :fields="cabezera"
        >
        <template #cell(codigo)="data">
            {{ data.item.codigo }}
          </template>
          <template #cell(producto)="data">
            {{ data.item.producto }}
          </template>
          <template #cell(existencia)="data">
            {{ data.item.existencia }}
          </template>
          <template #cell(opciones)="data">
            <b-button
              tabindex="0"
              v-b-tooltip.focus
              title="Eliminar"
              class="icon-content col-xl-8 col-lg-4 col-sm-"
              size="sm"
              variant="outline-danger"
              @click="eliminarDetalle(data)"
              ><i :class="'bx bx-trash-alt'"
            /></b-button>
          </template>
          <template #cell(precio_compra)="data">
            <b-form-input
              @keyup="updateDisableDates(data)"
              v-model="data.item.precio_compra"
              placeholder="Precio compra"
            ></b-form-input>
            <!-- money(data.item.precio_compra) -->
          </template>
          <template #cell(porcentaje_venta)="data">
            <b-form-input
              @keyup="updateporcentaje(data)"
              v-model="data.item.porcentaje_venta"
              placeholder="Porcentaje"
            ></b-form-input>
          </template>
          <template #cell(precio_venta)="data">
            <b-form-input
              @keyup="updateDisableDates(data)"
              v-model="data.item.precio_venta"
              placeholder="Precio compra"
            ></b-form-input>
          </template>
          <template #cell(subtotal)="data">
            {{ formatQuetzales(data.item.subtotal) }}
          </template>
          <!-- <template #cell(ubicaciones)="data">
                  <v-select 
                      v-model="data.item.ubicacion" :options="arrayDepa" 
                      :get-option-label="getLabel"
                  > </v-select>
              </template> -->
          <!-- <template #cell(unidad)="data">
                    {{data.item.presentacion}}
              </template> -->
          <template #cell(cantidad)="data">
            <b-form-input
              @keyup="updateDisableDates(data)"
              v-model="data.item.cantidad"
              placeholder="Cantidad"
            ></b-form-input>
          </template>
        </b-table>
        <div class="row">
          <div class="col-12">
            <div v-if="$v.arrayDetalle.$error">
              <div class="alert alert-danger">Debe ingresar detalles</div>
            </div>
          </div>
        </div>

        <!-- FOOUTER   -->
        <div class="row mt-4">
          <!-- end col -->
          <div class="col-sm-12">
            <div class="text-end">
              <div class="btn btn-success" @click="validaciones('save')">
                {{ tomandototal() }}
                <i class="mdi mdi-truck-fast me-1"></i> Guardar
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <!-- end row -->
  </Layout>
</template>
